import React from 'react';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import getUserFromMeetingInvite from '../../../../misc/getUserFromMeetingInvite';
import {useMyUserId} from '../../../../data/hooks/sessionHooks';
import MeetingStateIcon from '../../MeetingStateIcon';
import Link from '../../Link';
import EventTime from '../../EventTime';
import {getMeetingURL} from '../getMeetingURL';
import UserAvatar from '../../icons/UserAvatar';

function SingleMeeting(props) {
    const {className = '', event, meeting} = props,
        myUserId = useMyUserId(),
        i18n = useI18n();

    let user;
    if (meeting.initiator.id == myUserId) {
        user = getUserFromMeetingInvite(meeting.invited[0], i18n);
    } else {
        user = meeting.initiator;
    }

    return (
        <div className={['meeting', className, 'single'].join(' ')}>
            <div className="time">
                <EventTime event={event} time={meeting.start_local} />
            </div>
            <UserAvatar user={user} />
            <Link href={getMeetingURL(event.id, meeting.id)}>
                <div className="text">
                    <div className="location">{meeting.location.name}</div>
                    <div className="username">
                        {user.first_name} {user.last_name}
                    </div>
                </div>
            </Link>
            <MeetingStateIcon event={event} meeting={meeting} invite={meeting._myInvite} allowStateChange />
        </div>
    );
}

export default SingleMeeting;
